var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5022_507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5022_507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 13.3334C7.63366 13.3334 7.31977 13.2028 7.05866 12.9417C6.79755 12.6806 6.66699 12.3667 6.66699 12C6.66699 11.6334 6.79755 11.3195 7.05866 11.0584C7.31977 10.7972 7.63366 10.6667 8.00033 10.6667C8.36699 10.6667 8.68088 10.7972 8.94199 11.0584C9.2031 11.3195 9.33366 11.6334 9.33366 12C9.33366 12.3667 9.2031 12.6806 8.94199 12.9417C8.68088 13.2028 8.36699 13.3334 8.00033 13.3334ZM8.00033 9.33335C7.63366 9.33335 7.31977 9.2028 7.05866 8.94169C6.79755 8.68058 6.66699 8.36669 6.66699 8.00002C6.66699 7.63335 6.79755 7.31946 7.05866 7.05835C7.31977 6.79724 7.63366 6.66669 8.00033 6.66669C8.36699 6.66669 8.68088 6.79724 8.94199 7.05835C9.2031 7.31946 9.33366 7.63335 9.33366 8.00002C9.33366 8.36669 9.2031 8.68058 8.94199 8.94169C8.68088 9.2028 8.36699 9.33335 8.00033 9.33335ZM8.00033 5.33335C7.63366 5.33335 7.31977 5.2028 7.05866 4.94169C6.79755 4.68058 6.66699 4.36669 6.66699 4.00002C6.66699 3.63335 6.79755 3.31946 7.05866 3.05835C7.31977 2.79724 7.63366 2.66669 8.00033 2.66669C8.36699 2.66669 8.68088 2.79724 8.94199 3.05835C9.2031 3.31946 9.33366 3.63335 9.33366 4.00002C9.33366 4.36669 9.2031 4.68058 8.94199 4.94169C8.68088 5.2028 8.36699 5.33335 8.00033 5.33335Z",
    fill: "#2F2A2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.446422761db4a8992269c01354af8f76.svg";
export { ForwardRef as ReactComponent };